import React from 'react';
import { Hero } from '../components/home/Hero';
import { HowItWorksTease } from '../components/home/HowItWorksTease';
import { ImpactCounters } from '../components/home/ImpactCounters';
import { FounderStory } from '../components/home/FounderStory';
import { PartnerLogos } from '../components/home/PartnerLogos';
import { Testimonial } from '../components/home/Testimonial';
import { DonationTiers } from '../components/home/DonationTiers';
import { Newsletter } from '../components/home/Newsletter';
export function HomePage() {
  return <>
      <Hero data-id="element-524" />
      <HowItWorksTease data-id="element-525" />
      <ImpactCounters data-id="element-526" />
      <FounderStory data-id="element-527" />
      <PartnerLogos data-id="element-528" />
      <Testimonial data-id="element-529" />
      <DonationTiers data-id="element-530" />
      <Newsletter data-id="element-531" />
    </>;
}